import React from 'react';
import OpenRow from './Row';

const Body = ({ data }) => {
  return (
    <tbody>
      {data.map((order, i) => {
        let bgRow = i % 2 ? 'bg-gray-50' : 'bg-white';
        return (
          <OpenRow
            key={order.ticketId}
            ticketId={order.ticketId}
            name={order.name}
            status={order.status}
            submittedDate={order.submittedDate}
            lastUpdate={order.lastUpdate}
            type={order.type}
            priority={order.priority}
            source={order.source}
            bgRow={bgRow}
            orderGuideName={order.orderGuideName}
          />
        );
      })}
    </tbody>
  );
};

export default Body;
